import apiUrl from '../../../constants';
import commonFunction from '../../../commonFunction';
import constantVariable from '../../../constantVariable';
import directAppointmentService from '../../../services/directAppointment.service';
import {
  validateFileExtension,
  validateFileNotEmpty,
  parseCsvFile,
  validateParsedRows,
  dedupeValidUploadRecords,
  parseAppointmentTimeSlot,
  buildErrorCsvContent,
  buildSearchResultCsvContent,
  downloadTextFile,
  UPLOAD_HEADERS,
  validateAppointmentDate,
  isTomorrowTaggingCutoffPassed,
} from '../../../utils/directAppointmentValidation';
import Vue from 'vue';
import Paginate from 'vuejs-paginate';
import DatePicker from 'vue2-datepicker';
import { MultiSelect, BasicSelect } from 'vue-search-select';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import authFunction from '../../../authFunction';
import { AES } from 'crypto-js';
import moment from 'moment';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY hh:mm');
  }
});

export default {
  name: 'cargoshipment',
  components: {
    Paginate,
    DatePicker,
    Loading,
    MultiSelect,
    BasicSelect,
  },
  data() {
    return {
      isLoading: false,
      isLoadingPagination: false,
      isUploading: false,
      isSubmitting: false,
      isExporting: false,
      fullPage: false,
      showList: 0,
      listTotalCount: 0,
      pageNo: 0,
      pageCount: 0,
      perPage: 50,
      username: '',
      userid: '',
      OldDeliveryUserOrUserId: '',
      clientData: [],
      selectedClientOptions: [],
      txtShippingIDs: '',
      shippingIDs: [],
      fromPickUpDate: '',
      toPickUpDate: '',
      fromAppointmentDeliveryDate: '',
      toAppointmentDeliveryDate: '',
      fromTaggingDate: '',
      toTaggingDate: '',
      filterReferenceId: '',
      filterStatus: '',
      filterTaggedBy: '',
      statusData: [{ value: '', text: 'Select Status' }],
      taggedByData: [{ value: '', text: 'Select Tagged By' }],
      selectedStatusObj: {
        value: '',
        text: 'Select Status',
      },
      selectedTaggedByObj: {
        value: '',
        text: 'Select Tagged By',
      },
      tillDate1: '',
      tillDate2: '',
      appointmentList: [],
      uploadPreviewModal: false,
      uploadFile: null,
      uploadFileName: '',
      validUploadRecords: [],
      invalidUploadRecords: [],
      uploadErrors: [],
      submitResultModal: false,
      submitResultMsg: '',
      submitFailedRecords: [],
      displayMsg: false,
      successErrorMsg: '',
    };
  },
  filters: {
    moment: function (date) {
      if (!date) return;
      return moment(date).format('DD-MM-YYYY');
    },
  },
  mounted() {
    [, , this.userdetail] = commonFunction.getuserDetailsAndpermissionData();
    this.userid = this.userdetail[0].userid;
    this.username = this.userdetail[0].username;
    this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
    this.loadClientList();
  },
  computed: {
    tomorrowTaggingRuleActive() {
      return isTomorrowTaggingCutoffPassed();
    },
  },
  methods: {
    dateFormatYYYYMMDD(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormat1(date) {
      let returnDate = '';
      if (date) {
        returnDate = moment(date).format('YYYY-MM-DD') + ' 00:00:00';
      }
      return returnDate;
    },
    dateFormatToTime(date) {
      let returnDate = '';
      if (date) {
        returnDate = moment(date).format('YYYY-MM-DD') + ' 23:59:59';
      }
      return returnDate;
    },
    formatDisplayDate(value) {
      if (!value) {
        return '';
      }

      var str = String(value).trim();
      var parsed = moment(str, [
        'DD-MM-YYYY HH:mm:ss',
        'DD-MM-YYYY HH:mm',
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD',
        'DD-MM-YYYY',
      ], true);

      if (!parsed.isValid()) {
        parsed = moment(str);
      }

      return parsed.isValid() ? parsed.format('DD-MM-YYYY') : str;
    },
    formatDisplayTime(value) {
      if (!value) {
        return '';
      }

      var str = String(value).trim();
      if (/^([01]?\d|2[0-3]):[0-5]\d-([01]?\d|2[0-3]):[0-5]\d$/.test(str)) {
        return str;
      }

      if (/^([01]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(str)) {
        return str;
      }

      var parsed = moment(str, [
        'DD-MM-YYYY HH:mm:ss',
        'DD-MM-YYYY HH:mm',
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD HH:mm',
      ], true);

      if (!parsed.isValid()) {
        parsed = moment(str);
      }

      return parsed.isValid() ? parsed.format('HH:mm:ss') : str;
    },
    formatShipments() {
      this.txtShippingIDs = this.txtShippingIDs.replace(/(\r\n|\n|\r|\s)/gm, ',');
      this.txtShippingIDs = this.txtShippingIDs.split(/[\s,]+/).join();
    },
    selectedClientData(selectedClients) {
      this.selectedClientOptions = Array.isArray(selectedClients) ? selectedClients.slice() : [];
    },
    selectedStatusData(selectedStatusData) {
      this.selectedStatusObj = selectedStatusData || { value: '', text: 'Select Status' };
      this.filterStatus = this.selectedStatusObj.value;
    },
    selectedTaggedByData(selectedTaggedByData) {
      this.selectedTaggedByObj = selectedTaggedByData || { value: '', text: 'Select Tagged By' };
      this.filterTaggedBy = this.selectedTaggedByObj.value;
    },
    getSelectedClientIds() {
      if (!this.selectedClientOptions.length) {
        return '';
      }
      return this.selectedClientOptions.map((client) => client.value).join(',');
    },
    onChangePickUpDate() {
      if (this.fromPickUpDate != null && this.toPickUpDate != null) {
        if (this.fromPickUpDate !== '') {
          let dateDisabled = new Date(this.fromPickUpDate);
          this.tillDate1 = new Date();
          dateDisabled.setDate(this.fromPickUpDate.getDate() + 14);
          this.tillDate1 = dateDisabled;
        }
        if (this.toPickUpDate !== '') {
          let dateDisabled2 = new Date(this.toPickUpDate);
          this.tillDate2 = new Date();
          dateDisabled2.setDate(this.toPickUpDate.getDate() - 14);
          this.tillDate2 = dateDisabled2;
        }
      } else {
        this.fromPickUpDate = '';
        this.toPickUpDate = '';
        this.tillDate1 = '';
        this.tillDate2 = '';
      }
    },
    onChangeAppointmentDeliveryDate() {
      if (this.fromAppointmentDeliveryDate != null && this.toAppointmentDeliveryDate != null) {
        if (this.fromAppointmentDeliveryDate !== '') {
          let dateDisabled = new Date(this.fromAppointmentDeliveryDate);
          this.tillDate1 = new Date();
          dateDisabled.setDate(this.fromAppointmentDeliveryDate.getDate() + 14);
          this.tillDate1 = dateDisabled;
        }
        if (this.toAppointmentDeliveryDate !== '') {
          let dateDisabled2 = new Date(this.toAppointmentDeliveryDate);
          this.tillDate2 = new Date();
          dateDisabled2.setDate(this.toAppointmentDeliveryDate.getDate() - 14);
          this.tillDate2 = dateDisabled2;
        }
      } else {
        this.fromAppointmentDeliveryDate = '';
        this.toAppointmentDeliveryDate = '';
        this.tillDate1 = '';
        this.tillDate2 = '';
      }
    },
    async loadClientList() {
      try {
        const storedClients = directAppointmentService.getClientListFromStorage();
        if (storedClients.length) {
          this.clientData = storedClients;
          return;
        }

        let result = await directAppointmentService.getClientList();
        let clientData = directAppointmentService.mapClientListResponse(result);
        if (!clientData.length) {
          result = await directAppointmentService.getAllClientList();
          clientData = directAppointmentService.mapClientListResponse(result);
        }

        this.clientData = clientData;
      } catch (error) {
        this.$alertify.error(commonFunction.showNetworkError(error) + ' - getClientList');
      }
    },
    async updateStatusDropdownFromList(records, totalRows) {
      var allRecords = records || [];

      if (totalRows && totalRows > allRecords.length) {
        try {
          var searchData = this.buildCargoSearchPayload();
          searchData.PageIndex = 0;
          searchData.PageSize = totalRows;
          searchData.Status = '';

          var result = await directAppointmentService.getCargoShipmentData(searchData);
          if (result.data && result.data.data && result.data.data.ErrorCode != -1) {
            allRecords = (result.data.data.data && result.data.data.data.data) || allRecords;
          }
        } catch (error) {
          console.error(error);
        }
      }

      this.statusData = directAppointmentService.buildStatusOptionsFromRecords(allRecords);

      if (this.filterStatus) {
        var selectedStillExists = this.statusData.some((option) => option.value === this.filterStatus);
        if (!selectedStillExists) {
          this.filterStatus = '';
          this.selectedStatusObj = { value: '', text: 'Select Status' };
        } else {
          this.selectedStatusObj = this.statusData.find((option) => option.value === this.filterStatus) || {
            value: '',
            text: 'Select Status',
          };
        }
      }
    },
    async updateTaggedByDropdownFromList(records, totalRows) {
      var allRecords = records || [];

      if (totalRows && totalRows > allRecords.length) {
        try {
          var searchData = this.buildCargoSearchPayload();
          searchData.PageIndex = 0;
          searchData.PageSize = totalRows;
          searchData.TaggedBy = '';

          var result = await directAppointmentService.getCargoShipmentData(searchData);
          if (result.data && result.data.data && result.data.data.ErrorCode != -1) {
            allRecords = (result.data.data.data && result.data.data.data.data) || allRecords;
          }
        } catch (error) {
          console.error(error);
        }
      }

      this.taggedByData = directAppointmentService.buildTaggedByOptionsFromRecords(allRecords);

      if (this.filterTaggedBy) {
        var selectedStillExists = this.taggedByData.some((option) => option.value === this.filterTaggedBy);
        if (!selectedStillExists) {
          this.filterTaggedBy = '';
          this.selectedTaggedByObj = { value: '', text: 'Select Tagged By' };
        } else {
          this.selectedTaggedByObj = this.taggedByData.find((option) => option.value === this.filterTaggedBy) || {
            value: '',
            text: 'Select Tagged By',
          };
        }
      }
    },
    buildCargoSearchPayload() {
      var clientId = '';
      if (this.selectedClientOptions.length === 1) {
        clientId = this.selectedClientOptions[0].value;
      } else if (this.selectedClientOptions.length > 1) {
        clientId = this.getSelectedClientIds();
      }

      return {
        ClientID: clientId,
        ParentAWB: this.shippingIDs,
        FromPickUpDate: this.dateFormat1(this.fromPickUpDate),
        ToPickUpDate: this.dateFormatToTime(this.toPickUpDate),
        FromAppointmentDeliveryDate: this.dateFormat1(this.fromAppointmentDeliveryDate),
        ToAppointmentDeliveryDate: this.dateFormatToTime(this.toAppointmentDeliveryDate),
        ReferenceID: this.filterReferenceId,
        Status: this.filterStatus,
        appointmenttaggedby: this.filterTaggedBy,
        FromTaggingDate: this.dateFormat1(this.fromTaggingDate),
        ToTaggingDate: this.dateFormatToTime(this.toTaggingDate),
        NoAppointmentDate: 'N',
        PageIndex: this.pageNo,
        PageSize: this.perPage,
      };
    },
    searchButton() {
      this.shippingIDs = [];
      if (this.txtShippingIDs !== '') {
        let filter = this.txtShippingIDs.trim();
        let filterArr = filter.split(',');
        if (filterArr.length > 50) {
          this.$alertify.error('Please select Shipping IDs less than or equal to 50.');
          return false;
        }
        this.shippingIDs = filterArr;
      }
      this.showList = 0;
      this.listTotalCount = 0;
      this.appointmentList = [];
      this.pageNo = 0;
      this.pageCount = 0;
      this.getCargoShipmentData();
    },
    async getPaginationData(pageNum) {
      this.pageNo = pageNum - 1;
      await this.getCargoShipmentData();
    },
    getCargoShipmentData() {
      try {
        this.isLoading = true;
        this.listTotalCount = 0;
        this.appointmentList = [];

        var searchData = this.buildCargoSearchPayload();

        directAppointmentService.getCargoShipmentData(searchData).then((result) => {
          this.isLoading = false;
          this.isLoadingPagination = false;

          if (result.data.data) {
            this.showList = 1;

            if (result.data.data.ErrorCode == -1) {
              this.pageCount = 0;
              if (result.data.data.data && result.data.data.data.ReturnCode !== 100) {
                this.$alertify.error(result.data.data.msg);
              }
            } else {
              this.appointmentList = result.data.data.data.data || [];
              var totalRows = result.data.data.data.totalCount;

              if (totalRows > 0) {
                var appointmentListCnt = this.appointmentList.length;
                for (var i = 0; i < appointmentListCnt; i++) {
                  if (this.appointmentList[i].originhubid > 0) {
                    this.getHubDetailById(this.appointmentList[i].originhubid, i, 'O');
                    this.getHubDetailById(this.appointmentList[i].finaldestinationid, i, 'D');
                  }
                }

                this.listTotalCount = totalRows;

                if (!this.filterStatus) {
                  this.updateStatusDropdownFromList(this.appointmentList, totalRows);
                }

                if (!this.filterTaggedBy) {
                  this.updateTaggedByDropdownFromList(this.appointmentList, totalRows);
                }

                if (totalRows < this.perPage) {
                  this.pageCount = 1;
                  this.pageNo = 0;
                } else {
                  this.pageCount = Math.ceil(totalRows / this.perPage);
                }
              } else {
                this.pageCount = 0;
              }
            }
          } else {
            this.$alertify.error('API Error');
          }
        }, (error) => {
          this.isLoading = false;
          this.isLoadingPagination = false;
          this.$alertify.error(commonFunction.showNetworkError(error));
        });
      } catch (error) {
        this.isLoading = false;
        this.isLoadingPagination = false;
        this.$alertify.error(error + ' - getCargoShipmentData');
      }
    },
    getHubDetailById(HubId, HubSource, HubLoc) {
      try {
        this.fetchHubNameById(HubId).then((hubName) => {
          if (HubSource >= 0 && HubLoc === 'O') {
            this.appointmentList[HubSource].originhubid = hubName;
            this.appointmentList[HubSource].originBranch = hubName;
          } else if (HubSource >= 0 && HubLoc === 'D') {
            this.appointmentList[HubSource].finaldestinationid = hubName;
            this.appointmentList[HubSource].destinationBranch = hubName;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async fetchHubNameById(hubId) {
      if (!hubId || hubId <= 0) {
        return hubId || '';
      }
      if (typeof hubId === 'string' && isNaN(Number(hubId))) {
        return hubId;
      }

      try {
        const secretKey = constantVariable.enckey;
        const encryptedData = AES.encrypt(hubId.toString(), secretKey).toString();
        let ecHubId = encryptedData.replace(/[=]/g, '_');
        const result = await directAppointmentService.getHubDetailById(ecHubId);
        let resultDataCrm = result.data.data;
        if (resultDataCrm.status) {
          let response = resultDataCrm.data;
          if (response.code === 200 && response.data && response.data[0]) {
            return response.data[0].HubName;
          }
        }
      } catch (error) {
        console.error(error);
      }

      return hubId;
    },
    async resolveHubNamesForExport(records) {
      var hubCache = {};
      var hubIds = [];

      records.forEach(function (row) {
        if (row.originhubid > 0 && hubIds.indexOf(row.originhubid) === -1) {
          hubIds.push(row.originhubid);
        }
        if (row.finaldestinationid > 0 && hubIds.indexOf(row.finaldestinationid) === -1) {
          hubIds.push(row.finaldestinationid);
        }
      });

      for (var i = 0; i < hubIds.length; i++) {
        hubCache[hubIds[i]] = await this.fetchHubNameById(hubIds[i]);
      }

      records.forEach(function (row) {
        row.originBranch = hubCache[row.originhubid] || row.originBranch || row.originhubid;
        row.destinationBranch = hubCache[row.finaldestinationid] || row.destinationBranch || row.finaldestinationid;
      });

      return records;
    },
    resetForm() {
      this.showList = 0;
      this.listTotalCount = 0;
      this.pageCount = 0;
      this.appointmentList = [];
      this.fromPickUpDate = '';
      this.toPickUpDate = '';
      this.fromAppointmentDeliveryDate = '';
      this.toAppointmentDeliveryDate = '';
      this.fromTaggingDate = '';
      this.toTaggingDate = '';
      this.tillDate1 = '';
      this.tillDate2 = '';
      this.filterReferenceId = '';
      this.filterStatus = '';
      this.filterTaggedBy = '';
      this.statusData = [{ value: '', text: 'Select Status' }];
      this.taggedByData = [{ value: '', text: 'Select Tagged By' }];
      this.selectedStatusObj = { value: '', text: 'Select Status' };
      this.selectedTaggedByObj = { value: '', text: 'Select Tagged By' };
      this.txtShippingIDs = '';
      this.shippingIDs = [];
      this.selectedClientOptions = [];
    },
    openBulkUploadModal() {
      this.resetUploadState();
      this.uploadPreviewModal = true;
    },
    closeUploadPreviewModal() {
      this.uploadPreviewModal = false;
    },
    resetUploadState() {
      this.uploadFile = null;
      this.uploadFileName = '';
      this.validUploadRecords = [];
      this.invalidUploadRecords = [];
      this.uploadErrors = [];
      if (this.$refs.uploadFileInput) {
        this.$refs.uploadFileInput.value = '';
      }
    },
    handleUploadFileChange(event) {
      const file = event.target.files[0];
      this.uploadFile = file || null;
      this.uploadFileName = file ? file.name : '';
      this.validUploadRecords = [];
      this.invalidUploadRecords = [];
      this.uploadErrors = [];
    },
    async validateUploadFile() {
      try {
        if (!this.uploadFile) {
          this.$alertify.error('Please select a file to upload.');
          return;
        }

        const extensionResult = validateFileExtension(this.uploadFile.name);
        if (!extensionResult.valid) {
          this.$alertify.error(extensionResult.message);
          return;
        }

        const emptyResult = validateFileNotEmpty(this.uploadFile);
        if (!emptyResult.valid) {
          this.$alertify.error(emptyResult.message);
          return;
        }

        this.isUploading = true;
        this.uploadErrors = [];

        if (extensionResult.extension === 'csv') {
          const fileText = await this.readFileAsText(this.uploadFile);
          const parseResult = parseCsvFile(fileText);
          if (!parseResult.valid) {
            this.isUploading = false;
            this.$alertify.error(parseResult.message);
            return;
          }
          await this.processValidatedRows(parseResult.rows);
        } else {
          await this.validateExcelUploadViaBackend();
        }
      } catch (error) {
        this.isUploading = false;
        this.$alertify.error(commonFunction.showNetworkError(error));
      }
    },
    readFileAsText(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    applyFrontendAppointmentValidation(validRecords, invalidRecords) {
      var validatedValid = [];
      var validatedInvalid = (invalidRecords || []).slice();

      (validRecords || []).forEach(function (record, index) {
        var dateResult = validateAppointmentDate(record.appointmentDate);
        if (!dateResult.valid) {
          validatedInvalid.push({
            rowNumber: record.rowNumber || index + 2,
            awb: record.awb,
            appointmentDate: record.appointmentDate,
            appointmentTime: record.appointmentTime,
            referenceId: record.referenceId,
            remark: record.remark,
            errors: dateResult.message,
          });
          return;
        }

        validatedValid.push(Object.assign({}, record, {
          appointmentDate: dateResult.normalizedDate,
        }));
      });

      return {
        validUploadRecords: validatedValid,
        invalidUploadRecords: validatedInvalid,
      };
    },

    revalidateUploadRecordsBeforeSubmit() {
      var validated = this.applyFrontendAppointmentValidation(
        this.validUploadRecords,
        this.invalidUploadRecords
      );

      this.validUploadRecords = validated.validUploadRecords;
      this.invalidUploadRecords = validated.invalidUploadRecords;

      return this.validUploadRecords.length > 0;
    },

    async processValidatedRows(rows) {
      const frontendResult = validateParsedRows(rows);
      this.validUploadRecords = frontendResult.validUploadRecords;
      this.invalidUploadRecords = frontendResult.invalidUploadRecords;

      if (frontendResult.duplicateCount > 0) {
        this.$alertify.warning(
          frontendResult.duplicateCount + ' duplicate AWB record(s) found and excluded from submission.'
        );
      }

      if (this.validUploadRecords.length === 0) {
        this.isUploading = false;
        this.$alertify.error('No valid records found in uploaded file.');
        return;
      }

      try {
        // const backendResult = await directAppointmentService.validateDirectAppointmentUpload({
        //   records: this.validUploadRecords,
        //   LastModifiedBy: this.username,
        // });

        // this.mergeBackendValidation(backendResult);
        this.isUploading = false;
        this.$alertify.success('File validated. Please review results before submission.');
      } catch (error) {
        this.isUploading = false;
        this.$alertify.warning(
          'Frontend validation completed. Backend validation API is unavailable; submit may fail until backend is ready.'
        );
      }
    },
    mergeBackendValidation(result) {
      const resultData = result.data && result.data.data;
      if (!resultData || !resultData.status) {
        return;
      }

      const payload = resultData.data || {};
      const backendInvalid = payload.invalidRecords || [];
      const backendValid = payload.validRecords || [];

      if (backendInvalid.length) {
        backendInvalid.forEach((row) => {
          this.invalidUploadRecords.push({
            rowNumber: row.rowNumber || '',
            awb: row.awb || '',
            appointmentDate: row.appointmentDate || '',
            appointmentTime: row.appointmentTime || '',
            referenceId: row.referenceId || '',
            remark: row.remark || '',
            errors: row.errors || row.errorMessage || 'Backend validation failed.',
          });
        });
      }

      if (backendValid.length) {
        const deduped = dedupeValidUploadRecords(backendValid, this.invalidUploadRecords);
        this.validUploadRecords = deduped.validUploadRecords;
        this.invalidUploadRecords = deduped.invalidUploadRecords;
        if (deduped.duplicateCount > 0) {
          this.$alertify.warning(
            deduped.duplicateCount + ' duplicate AWB record(s) found and excluded from submission.'
          );
        }
      } else if (backendInvalid.length) {
        const invalidAwbs = backendInvalid.map((r) => r.awb);
        this.validUploadRecords = this.validUploadRecords.filter((r) => invalidAwbs.indexOf(r.awb) === -1);
      }
    },
    async validateExcelUploadViaBackend() {
      try {
        const formData = new FormData();
        formData.append('file', this.uploadFile);
        formData.append('LastModifiedBy', this.username);

        const result = await directAppointmentService.validateDirectAppointmentUploadFile(formData);
        const resultData = result.data && result.data.data;

        if (resultData && resultData.status) {
          const payload = resultData.data || {};
          const frontendValidated = this.applyFrontendAppointmentValidation(
            payload.validRecords || [],
            payload.invalidRecords || []
          );
          const deduped = dedupeValidUploadRecords(
            frontendValidated.validUploadRecords,
            frontendValidated.invalidUploadRecords
          );
          this.validUploadRecords = deduped.validUploadRecords;
          this.invalidUploadRecords = deduped.invalidUploadRecords;
          this.isUploading = false;
          if (deduped.duplicateCount > 0) {
            this.$alertify.warning(
              deduped.duplicateCount + ' duplicate AWB record(s) found and excluded from submission.'
            );
          }
          if (this.validUploadRecords.length === 0) {
            this.$alertify.error('No valid records found in uploaded file.');
          } else {
            this.$alertify.success('File validated. Please review results before submission.');
          }
        } else {
          this.isUploading = false;
          this.$alertify.error((resultData && resultData.msg) || 'Failed to validate uploaded file.');
        }
      } catch (error) {
        this.isUploading = false;
        this.$alertify.error(
          'Excel validation requires backend API (' +
            directAppointmentService.API_ENDPOINTS.VALIDATE_DIRECT_APPOINTMENT_UPLOAD +
            '). Please use CSV or implement the backend endpoint.'
        );
      }
    },
    downloadUploadErrorFile() {
      if (!this.invalidUploadRecords.length) {
        this.$alertify.error('No invalid records to download.');
        return;
      }
      const content = buildErrorCsvContent(this.invalidUploadRecords);
      downloadTextFile(content, 'DirectAppointmentUploadErrors.csv');
    },
    // parseAppointmentTimeSlot moved to directAppointmentValidation.js
    trackSingleAppointmentSubmission(awb) {
      authFunction.userTrackerB2BAppointment({
        subReason: 'B2B Update Appointment',
        shippingIds: awb,
        userid: this.userid,
        username: this.username,
        olduserid: this.OldDeliveryUserOrUserId,
        projectname: apiUrl.project_name,
        trackurl: this.$route.path,
        eventTrack: 'B2B Update Appointment',
      });
    },
    downloadSubmitErrorFile() {
      if (!this.submitFailedRecords.length) {
        this.$alertify.error('No failed records to download.');
        return;
      }
      const header = UPLOAD_HEADERS.concat(['Error']).join(',');
      const lines = this.submitFailedRecords.map((row) => {
        return [
          row.awb || '',
          row.appointmentDate || '',
          row.appointmentTime || '',
          row.referenceId || '',
          (row.remark || '').replace(/,/g, ' '),
          (row.errorMessage || row.errors || '').replace(/,/g, ' '),
        ].join(',');
      });
      downloadTextFile([header].concat(lines).join('\n'), 'DirectAppointmentSubmitErrors.csv');
    },
    async submitDirectAppointments() {
      try {
        if (!this.validUploadRecords.length) {
          this.$alertify.error('No valid records available for submission.');
          return;
        }

        const dedupedSubmit = dedupeValidUploadRecords(this.validUploadRecords, this.invalidUploadRecords);
        this.validUploadRecords = dedupedSubmit.validUploadRecords;
        this.invalidUploadRecords = dedupedSubmit.invalidUploadRecords;

        if (!this.validUploadRecords.length) {
          this.$alertify.error('No valid records available for submission after removing duplicates.');
          return;
        }

        if (dedupedSubmit.duplicateCount > 0) {
          this.$alertify.warning(
            dedupedSubmit.duplicateCount + ' duplicate AWB record(s) removed before submission.'
          );
        }

        if (!this.revalidateUploadRecordsBeforeSubmit()) {
          this.$alertify.error('No valid records available for submission after re-validation.');
          if (this.invalidUploadRecords.length) {
            this.$alertify.error('Tomorrow\'s appointment must be tagged before 7 PM.');
          }
          return;
        }

        this.isSubmitting = true;
        this.submitFailedRecords = [];
        var successCount = 0;
        var recordsToSubmit = this.validUploadRecords;

        for (var i = 0; i < recordsToSubmit.length; i++) {
          var record = recordsToSubmit[i];
          var timeSlot = parseAppointmentTimeSlot(record.appointmentTime);
          var reqDataApi = {
            ParentAWB: record.awb,
            AppointmentDeliveryDate: record.appointmentDate,
            AppointmentTimeSlot: timeSlot.timeSlot,
            ReferenceID: record.referenceId,
            Remark: record.remark,
            LastModifiedBy: this.username,
          };

          try {
            var result = await directAppointmentService.saveBulkShipmentAppointment(reqDataApi);
            var resultDataCrm = result.data.data;

            if (resultDataCrm.status) {
              var resultData = result.data.data.data;
              if (resultData.ReturnCode == 100) {
                successCount++;
                this.trackSingleAppointmentSubmission(record.awb);
              } else {
                this.submitFailedRecords.push({
                  awb: record.awb,
                  appointmentDate: record.appointmentDate,
                  appointmentTime: record.appointmentTime,
                  referenceId: record.referenceId,
                  remark: record.remark,
                  errorMessage: resultData.ReturnMessage,
                });
              }
            } else {
              this.submitFailedRecords.push({
                awb: record.awb,
                appointmentDate: record.appointmentDate,
                appointmentTime: record.appointmentTime,
                referenceId: record.referenceId,
                remark: record.remark,
                errorMessage: resultDataCrm.msg,
              });
            }
          } catch (error) {
            this.submitFailedRecords.push({
              awb: record.awb,
              appointmentDate: record.appointmentDate,
              appointmentTime: record.appointmentTime,
              referenceId: record.referenceId,
              remark: record.remark,
              errorMessage: commonFunction.showNetworkError(error),
            });
          }
        }

        this.isSubmitting = false;

        if (successCount === recordsToSubmit.length) {
          this.$alertify.success('Appointment details added/updated successfully.');
          this.resetUploadState();
          this.closeUploadPreviewModal();
          this.searchButton();
        } else if (successCount > 0) {
          this.submitResultMsg =
            successCount + ' appointment(s) submitted successfully. ' + this.submitFailedRecords.length + ' failed.';
          this.submitResultModal = true;
          this.$alertify.warning('Some records failed. Review the result for details.');
          this.resetUploadState();
          this.closeUploadPreviewModal();
          this.searchButton();
        } else {
          this.submitResultMsg = 'Failed to submit appointments.';
          this.submitResultModal = true;
          this.$alertify.error('Failed to submit appointments.');
        }
      } catch (error) {
        this.isSubmitting = false;
        this.$alertify.error(commonFunction.showNetworkError(error));
      }
    },
    closeSubmitResultModal() {
      this.submitResultModal = false;
      this.submitResultMsg = '';
      this.submitFailedRecords = [];
    },
    async exportSearchResultsToCsv() {
      try {
        if (!this.showList || !this.listTotalCount) {
          this.$alertify.error('Please search and ensure data is available before export.');
          return false;
        }

        this.isExporting = true;
        var searchData = this.buildCargoSearchPayload();
        searchData.PageIndex = 0;
        searchData.PageSize = this.listTotalCount;

        var result = await directAppointmentService.getCargoShipmentData(searchData);

        if (!result.data || !result.data.data || result.data.data.ErrorCode == -1) {
          this.isExporting = false;
          this.$alertify.error((result.data && result.data.data && result.data.data.msg) || 'Failed to fetch data for export.');
          return;
        }

        var records = (result.data.data.data && result.data.data.data.data) || [];
        if (!records.length) {
          this.isExporting = false;
          this.$alertify.error('No data found to export.');
          return;
        }

        records = await this.resolveHubNamesForExport(records);
        var csvContent = buildSearchResultCsvContent(records);
        downloadTextFile(csvContent, 'DirectAppointmentSearchReport.csv');
        this.isExporting = false;
      } catch (error) {
        this.isExporting = false;
        this.$alertify.error(commonFunction.showNetworkError(error));
      }
    },
    downloadUploadTemplate() {
      const sample = [
        UPLOAD_HEADERS.join(','),
        '1234567890,2026-08-15,10:20:00,REF123,Customer requested morning delivery',
        '9876543210,2026-08-16,,,',
      ].join('\n');
      downloadTextFile(sample, 'DirectAppointmentUploadTemplate.csv');
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/cargoappointment/cargoappointment.component.js